import React, { useState, useContext, useEffect } from 'react'
import { useNavigate, useLocation } from "react-router-dom";
import { Container, Row, Form, Col, FormSelect, Button, Table, Modal, InputGroup } from "react-bootstrap";
import { ToastContainer } from 'react-toastify';
import AuthContext from '../../context/AuthContext';
import axiosInstance from '../../utils/axios';
import { fnOnChange } from '../reusables/CommonFunction';
import { fnFormValidation, fnMobileNumberValidation, fnEmailValidation } from '../reusables/HelperFormValidation';
import { format } from 'date-fns';
import { showToast } from '../reusables/CommonFunction';
import BusyLoaderOverlay from '../reusables/BusyLoaderOverlay';
import CustomTimePicker from '../reusables/CustomTimePicker';

const NewAppointment = () => {
    let { userDetails, clinicBranchDetails } = useContext(AuthContext)
    const navigate = useNavigate()
    const location = useLocation();
    const selectedDate = location.state?.selectedButtonDate === undefined ? new Date() : location.state.selectedButtonDate;
    const salutation = { '1': 'DR.', '2': 'MR.', '3': 'MRS.', '4': 'MISS', '5': 'MASTER' }
    const [loading, setLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [isPatientAdult, setPatientAdult] = useState(true)
    const [checkVisitorType, setCheckVisitorType] = useState('')
    const [isVisitorMarried, setVisitorMarried] = useState(false)
    const [isExistingPatientModalOpen, setIsExistingPatientModalOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState("")
    const [patientDetails, setPatientDetails] = useState([])
    const [newAppointmentDetailsState, setNewAppointmentDetailsState] = useState({
        clinic_id: userDetails.clinic_id,
        clinic_branch_id: "",
        slug: "",
        salutation: "",
        visitor_name: "",
        visitor_type: "",
        patient_case_number: "",
        accompanied_by: "",
        referred_by: "",
        age: "",
        gender: "",
        marital_status: "",
        married_since: "",
        name_of_parent_if_minor: "",
        mobile_number: "",
        email_id: "",
        patient_address: "",
        patient_city: "",
        appointment_date: format(new Date(selectedDate), 'yyyy-MM-dd'),
        appointment_time: "",
        status: "U",
        patient_reference_id: ""
    });

    const [newAppointmentDetailsErrors, setNewAppointmentDetailsErrors] = useState({
        slug: "",
        clinic_branch_id: "",
        salutation: "",
        visitor_name: "",
        visitor_type: "",
        patient_case_number: "",
        accompanied_by: "",
        referred_by: "",
        age: "",
        gender: "",
        marital_status: "",
        married_since: "",
        name_of_parent_if_minor: "",
        mobile_number: "",
        email_id: "",
        patient_address: "",
        patient_city: "",
        appointment_date: "",
        appointment_time: "",
        status: "",
    });

    useEffect(() => {
        if (clinicBranchDetails.length === 1) {
            setNewAppointmentDetailsState((prev) => ({
                ...prev,
                clinic_branch_id: clinicBranchDetails[0].clinic_branch_id
            }));
        }
    }, [clinicBranchDetails]);

    /* Add new Appointment */
    const onPressSubmitNewAppointment = (oEvent) => {
        oEvent.preventDefault();
        if (isSubmitting) return; // Prevent duplicate submissions

        setIsSubmitting(true);
        let fErrorStatus = []
        const aErrorMessage = ['visitor_type', 'clinic_branch_id', 'salutation', 'visitor_name', 'gender', 'mobile_number', 'appointment_date', 'appointment_time']
        fErrorStatus = fnFormValidation(newAppointmentDetailsState, newAppointmentDetailsErrors, setNewAppointmentDetailsErrors, aErrorMessage)

        const aMobileNumberLengthCheck = ['mobile_number']
        fErrorStatus = fnMobileNumberValidation(newAppointmentDetailsState, newAppointmentDetailsErrors, setNewAppointmentDetailsErrors, aMobileNumberLengthCheck, fErrorStatus)
        fErrorStatus = fnEmailValidation(newAppointmentDetailsState, newAppointmentDetailsErrors, setNewAppointmentDetailsErrors, ['email_id'], fErrorStatus)

        if (fErrorStatus.length === 0) {
            setLoading(true)
            axiosInstance
                .post("/appointments/", newAppointmentDetailsState)
                .then(response => {
                    if (response.status === 201) {
                        showToast("success", response.data.message);
                        setNewAppointmentDetailsState({
                            clinic_id: userDetails.clinic_id,
                            clinic_branch_id: "",
                            slug: "",
                            salutation: "",
                            visitor_name: "",
                            visitor_type: "",
                            patient_case_number: "",
                            accompanied_by: "",
                            referred_by: "",
                            age: "",
                            gender: "",
                            marital_status: "",
                            married_since: "",
                            name_of_parent_if_minor: "",
                            mobile_number: "",
                            email_id: "",
                            patient_address: "",
                            patient_city: "",
                            appointment_date: format(new Date(selectedDate), 'yyyy-MM-dd'),
                            appointment_time: "",
                            status: "U",
                        })
                        setNewAppointmentDetailsErrors({
                            slug: "",
                            clinic_branch_id: "",
                            salutation: "",
                            visitor_name: "",
                            visitor_type: "",
                            patient_case_number: "",
                            accompanied_by: "",
                            referred_by: "",
                            age: "",
                            gender: "",
                            marital_status: "",
                            married_since: "",
                            name_of_parent_if_minor: "",
                            mobile_number: "",
                            email_id: "",
                            patient_address: "",
                            patient_city: "",
                            appointment_date: "",
                            appointment_time: "",
                            status: "",
                        })
                        navigate("/appointment", { replace: true });
                    } else if (response.status === 403 && response.data.detail === "Your clinic plan has expired.") {
                        showToast("error", "You cannot create a new appointment as your clinic plan has expired. Please renew your plan to manage appointments.");
                    }
                })
                .catch(error => {
                    if (error.response && error.response.status === 403 && error.response.data.detail === "Your clinic plan has expired.") {
                        showToast("error", "You cannot create a new appointment as your clinic plan has expired. Please renew your plan to manage appointments.");
                    } else {
                        if (error.response && error.response.data) {
                            Object.entries(error.response.data).forEach(([key, messages]) => {
                                let formattedKey = key
                                    .replaceAll("_", " ") // Replace underscores with spaces
                                    .replace(/([A-Z])/g, " $1") // Add space before capital letters
                                    .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter of each word

                                let errorMessage = messages[0];
                                showToast("error", `${formattedKey} | ${errorMessage}`);
                            });
                        } else {
                            showToast("error", "An unexpected error occurred.");
                        }
                    }
                })
                .finally(() => {
                    setIsSubmitting(false);
                    setLoading(false);
                });
        } else {
            fErrorStatus.forEach((error) => {
                showToast("error", error);
            });
            setIsSubmitting(false);
        }
    }

    /* Search Existing Patient */
    const onPressSearchPatient = (oEvent) => {
        oEvent.preventDefault();
        if (!searchQuery.trim()) {
            showToast("error", "Please enter a patient name or case number to search.");
            return;
        }

        setLoading(true);
        axiosInstance
            .get(`/patients/`, {
                params: {
                    q: searchQuery,
                    clinicId: userDetails.clinic_id
                }
            })
            .then(response => {
                if (response.status === 200) {
                    setPatientDetails(response.data.data)
                }
            })
            .catch(error => {
            })
            .finally(() => {
                setLoading(false);
            });
    }

    const onFocusOut = (oEvent, pCurrentState, pSetCurrentState, pCurrentErrorState, pSetCurrentErrorState) => {
        if (oEvent.target.name === 'age') {
            if (Number(oEvent.target.value) < 18) {
                setPatientAdult(false)
            } else {
                setPatientAdult(true)
                pSetCurrentState({ ...pCurrentState, ['name_of_parent_if_minor']: '' })
            }
        }
    };

    const onPressConfirmPatient = (oEvent, pExistingPatient) => {
        oEvent.preventDefault();
        setIsExistingPatientModalOpen(false)
        setNewAppointmentDetailsState({
            clinic_id: userDetails.clinic_id,
            clinic_branch_id: pExistingPatient.clinic_branch_id,
            slug: pExistingPatient.patient_id,
            salutation: pExistingPatient.salutation,
            visitor_name: pExistingPatient.patient_name,
            visitor_type: 'E',
            patient_case_number: pExistingPatient.patient_case_number,
            accompanied_by: pExistingPatient.accompanied_by,
            referred_by: pExistingPatient.referred_by,
            age: pExistingPatient.age,
            gender: pExistingPatient.gender,
            marital_status: pExistingPatient.marital_status,
            married_since: pExistingPatient.married_since,
            name_of_parent_if_minor: pExistingPatient.name_of_parent_if_minor,
            mobile_number: pExistingPatient.mobile_number,
            email_id: pExistingPatient.email_id,
            patient_address: pExistingPatient.patient_address,
            patient_city: pExistingPatient.patient_city,
            appointment_date: format(new Date(selectedDate), 'yyyy-MM-dd'),
            appointment_time: "",
            status: "U",
            patient_reference_id: pExistingPatient.patient_id
        })
        setNewAppointmentDetailsErrors({
            slug: "",
            clinic_branch_id: "",
            salutation: "",
            visitor_name: "",
            visitor_type: "",
            patient_case_number: "",
            accompanied_by: "",
            referred_by: "",
            age: "",
            gender: "",
            marital_status: "",
            married_since: "",
            name_of_parent_if_minor: "",
            mobile_number: "",
            email_id: "",
            patient_address: "",
            patient_city: "",
            appointment_date: "",
            appointment_time: "",
            status: "",
        })

        if (Number(pExistingPatient.age) < 18) {
            setPatientAdult(false)
        } else {
            setPatientAdult(true)
        }
    }

    return (
        <>
            <Container className="ml-3 mr-3 mb-3">
                <Row>
                    <div className='col-md-12'>
                        <div className='content-section col-md-8'>
                            <legend className="border-bottom mb-4">New Appointment</legend>
                            <Form autoComplete="off" noValidate>
                                <Form.Group className='mb-3' controlId="formVisitor Type">
                                    <Form.Label className="required">Visitor Type</Form.Label>
                                    <Form.Control
                                        as={FormSelect}
                                        name="visitor_type"
                                        value={newAppointmentDetailsState.visitor_type || ""}
                                        onChange={(oEvent) => {
                                            setPatientDetails([])
                                            setIsExistingPatientModalOpen(oEvent.target.value === 'E' ? true : false)
                                            setCheckVisitorType(oEvent.target.value)
                                            fnOnChange(oEvent, newAppointmentDetailsState, setNewAppointmentDetailsState, newAppointmentDetailsErrors, setNewAppointmentDetailsErrors)
                                            setNewAppointmentDetailsState({
                                                clinic_id: userDetails.clinic_id,
                                                clinic_branch_id: "",
                                                slug: "",
                                                salutation: "",
                                                visitor_name: "",
                                                visitor_type: oEvent.target.value,
                                                accompanied_by: "",
                                                referred_by: "",
                                                age: "",
                                                gender: "",
                                                marital_status: "",
                                                married_since: "",
                                                name_of_parent_if_minor: "",
                                                mobile_number: "",
                                                email_id: "",
                                                patient_address: "",
                                                patient_city: "",
                                                appointment_date: format(new Date(selectedDate), 'yyyy-MM-dd'),
                                                appointment_time: "",
                                                status: "U",
                                            })
                                        }}
                                        isInvalid={newAppointmentDetailsErrors.visitor_type}>
                                        <option value="">Select Visitor Type</option>
                                        <option value="N">New Patient</option>
                                        <option value="E">Existing Patient</option>
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">{newAppointmentDetailsErrors.visitor_type}</Form.Control.Feedback>
                                </Form.Group>

                                <Modal size="lg" backdrop="static" keyboard={false} centered
                                    show={isExistingPatientModalOpen}
                                    onHide={() => { setCheckVisitorType(""); setIsExistingPatientModalOpen(false) }} >
                                    <Modal.Header closeButton>
                                        <Modal.Title>Search Existing Patient</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <Row className="ml-3 mr-3 mb-3">
                                            <div className='col-md-12'>
                                                <InputGroup className="mb-3 pl-0" >
                                                    <Form.Control
                                                        type="text"
                                                        name="searchQuery"
                                                        onChange={(oEvent) => setSearchQuery(oEvent.target.value)}
                                                        onKeyDown={(oEvent) => oEvent.key === "Enter" && onPressSearchPatient(oEvent)}
                                                        placeholder="Type patient name or case number and press Enter..."
                                                    />
                                                    <Button type="submit" variant="outline-secondary" onClick={onPressSearchPatient}>
                                                        Search
                                                    </Button>
                                                </InputGroup>

                                                {/* If the count is 0 then hide the table */}
                                                {patientDetails.length > 0 ?
                                                    <Table bordered hover responsive>
                                                        <thead light="true">
                                                            <tr>
                                                                <th style={{ width: "2rem" }}>#</th>
                                                                <th style={{ width: "18rem" }}>Patient Name</th>
                                                                <th style={{ width: "10rem" }}>Case Number</th>
                                                                <th style={{ width: "10rem" }}>Mobile Number</th>
                                                                <th style={{ width: "7rem" }}></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {patientDetails.map((patient, index) => {
                                                                return [
                                                                    <tr key={patient.patient_id}>
                                                                        <td>{index + 1}</td>
                                                                        <td className='text-left'>{salutation[patient.salutation]} {patient.patient_name}</td>
                                                                        <td className='text-left'>{patient.patient_case_number}</td>
                                                                        <td className='text-left'>{patient.mobile_number}</td>
                                                                        <td><Button type='button' variant='info' size='sm' onClick={oEvent => onPressConfirmPatient(oEvent, patient)} >Confirm</Button></td>
                                                                    </tr>
                                                                ]
                                                            })}
                                                        </tbody>
                                                    </Table>
                                                    : <> </>}
                                            </div>
                                        </Row>

                                    </Modal.Body>
                                </Modal>

                                <Form.Group className='d-none' controlId="formVisitorCaseNumber">
                                    <Form.Label>Visitor Case Number</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="patient_case_number"
                                        placeholder='Visitor Case Number'
                                        value={newAppointmentDetailsState.patient_case_number || ""}
                                        onChange={(oEvent) => fnOnChange(oEvent, newAppointmentDetailsState, setNewAppointmentDetailsState, newAppointmentDetailsErrors, setNewAppointmentDetailsErrors)}
                                        isInvalid={newAppointmentDetailsState.patient_case_number}
                                    />
                                    <Form.Control.Feedback type="invalid">{newAppointmentDetailsErrors.patient_case_number}</Form.Control.Feedback>
                                </Form.Group>

                                <Row className={checkVisitorType === "" ? 'd-none' : 'mb-3'}>
                                    <Form.Group as={Col} sm={4} controlId="formSalutation">
                                        <Form.Label className="required">Salutation</Form.Label>
                                        <Form.Control
                                            as={FormSelect}
                                            name="salutation"
                                            value={newAppointmentDetailsState.salutation || ""}
                                            onChange={(oEvent) => fnOnChange(oEvent, newAppointmentDetailsState, setNewAppointmentDetailsState, newAppointmentDetailsErrors, setNewAppointmentDetailsErrors)}
                                            isInvalid={newAppointmentDetailsErrors.salutation}>
                                            <option value="">Select Salutation</option>
                                            <option value="1">DR.</option>
                                            <option value="2">MR.</option>
                                            <option value="3">MRS.</option>
                                            <option value="4">MISS</option>
                                            <option value="5">MASTER</option>
                                        </Form.Control>
                                    </Form.Group>

                                    <Form.Group as={Col} controlId="formVisitorName">
                                        <Form.Label className="required">Visitor Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="visitor_name"
                                            placeholder='Visitor Name'
                                            value={newAppointmentDetailsState.visitor_name || ""}
                                            onChange={(oEvent) => {
                                                oEvent.target.value = oEvent.target.value.toUpperCase()
                                                fnOnChange(oEvent, newAppointmentDetailsState, setNewAppointmentDetailsState, newAppointmentDetailsErrors, setNewAppointmentDetailsErrors)
                                            }}
                                            isInvalid={newAppointmentDetailsErrors.visitor_name}
                                        />
                                        <Form.Control.Feedback type="invalid">{newAppointmentDetailsErrors.visitor_name}</Form.Control.Feedback>
                                    </Form.Group>
                                </Row>

                                <Row className={checkVisitorType === "" ? 'd-none' : 'mb-3'}>
                                    <Form.Group as={Col} controlId="formAccompaniedBy">
                                        <Form.Label>Accompanied By</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="accompanied_by"
                                            placeholder='Accompanied By'
                                            value={newAppointmentDetailsState.accompanied_by || ""}
                                            onChange={(oEvent) => {
                                                oEvent.target.value = oEvent.target.value.toUpperCase()
                                                fnOnChange(oEvent, newAppointmentDetailsState, setNewAppointmentDetailsState, newAppointmentDetailsErrors, setNewAppointmentDetailsErrors)
                                            }}
                                            isInvalid={newAppointmentDetailsErrors.accompanied_by}
                                        />
                                        <Form.Control.Feedback type="invalid">{newAppointmentDetailsErrors.accompanied_by}</Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group as={Col} controlId="formAccompaniedBy">
                                        <Form.Label>Referred By</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="referred_by"
                                            placeholder='Referred By'
                                            value={newAppointmentDetailsState.referred_by || ""}
                                            onChange={(oEvent) => {
                                                oEvent.target.value = oEvent.target.value.toUpperCase()
                                                fnOnChange(oEvent, newAppointmentDetailsState, setNewAppointmentDetailsState, newAppointmentDetailsErrors, setNewAppointmentDetailsErrors)
                                            }}
                                            isInvalid={newAppointmentDetailsErrors.referred_by}
                                        />
                                        <Form.Control.Feedback type="invalid">{newAppointmentDetailsErrors.referred_by}</Form.Control.Feedback>
                                    </Form.Group>
                                </Row>

                                <Row className={checkVisitorType === "" ? 'd-none' : 'mb-3'}>
                                    <Form.Group as={Col} controlId="formAge">
                                        <Form.Label>Age</Form.Label>
                                        <Form.Control
                                            type="number"
                                            name="age"
                                            placeholder='Age'
                                            value={newAppointmentDetailsState.age}
                                            onChange={(oEvent) => fnOnChange(oEvent, newAppointmentDetailsState, setNewAppointmentDetailsState, newAppointmentDetailsErrors, setNewAppointmentDetailsErrors)}
                                            onBlur={(oEvent) => onFocusOut(oEvent, newAppointmentDetailsState, setNewAppointmentDetailsState, newAppointmentDetailsErrors, setNewAppointmentDetailsErrors)}
                                            isInvalid={newAppointmentDetailsErrors.age}
                                        />
                                        <Form.Control.Feedback type="invalid">{newAppointmentDetailsErrors.age}</Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group as={Col} controlId="formGender">
                                        <Form.Label className="required">Gender</Form.Label>
                                        <Form.Control
                                            as={FormSelect}
                                            name="gender"
                                            value={newAppointmentDetailsState.gender || ""}
                                            onChange={(oEvent) => fnOnChange(oEvent, newAppointmentDetailsState, setNewAppointmentDetailsState, newAppointmentDetailsErrors, setNewAppointmentDetailsErrors)}
                                            isInvalid={newAppointmentDetailsErrors.gender}>
                                            <option value="">Select Gender</option>
                                            <option value="F">Female</option>
                                            <option value="M">Male</option>
                                            <option value="O">Others</option>
                                        </Form.Control>
                                        <Form.Control.Feedback type="invalid">{newAppointmentDetailsErrors.gender}</Form.Control.Feedback>
                                    </Form.Group>
                                </Row>

                                <Row className={checkVisitorType === "" ? 'd-none' : 'mb-3'}>
                                    <Form.Group as={Col} controlId="formMaritalStatus">
                                        <Form.Label>Marital Status</Form.Label>
                                        <Form.Control
                                            as={FormSelect}
                                            name="marital_status"
                                            value={newAppointmentDetailsState.marital_status || ""}
                                            onChange={(oEvent) => {
                                                if (oEvent.target.value === "M") {
                                                    setVisitorMarried(true)
                                                } else {
                                                    setVisitorMarried(false)
                                                }
                                                fnOnChange(oEvent, newAppointmentDetailsState, setNewAppointmentDetailsState, newAppointmentDetailsErrors, setNewAppointmentDetailsErrors)
                                            }}
                                            isInvalid={newAppointmentDetailsErrors.marital_status}>
                                            <option value="">Select Marital Status</option>
                                            <option value="UM">Unmarried</option>
                                            <option value="DP">Domestic Partnership</option>
                                            <option value="M">Married</option>
                                            <option value="SE">Separated</option>
                                            <option value="DI">Divorced</option>
                                            <option value="WI">Widowed</option>
                                        </Form.Control>
                                        <Form.Control.Feedback type="invalid">{newAppointmentDetailsErrors.marital_status}</Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group as={Col} className={isVisitorMarried ? "" : "d-none"} controlId="formMarriedSince">
                                        <Form.Label>Married Since</Form.Label>
                                        <Form.Control
                                            type="number"
                                            name="married_since"
                                            placeholder='Married Since'
                                            value={newAppointmentDetailsState.married_since}
                                            onChange={(oEvent) => fnOnChange(oEvent, newAppointmentDetailsState, setNewAppointmentDetailsState, newAppointmentDetailsErrors, setNewAppointmentDetailsErrors)}
                                            isInvalid={newAppointmentDetailsErrors.married_since}
                                        />
                                        <Form.Control.Feedback type="invalid">{newAppointmentDetailsErrors.married_since}</Form.Control.Feedback>
                                    </Form.Group>
                                </Row>

                                <Form.Group className={isPatientAdult ? "d-none" : "mb-3"} controlId="formNameOfParent">
                                    <Form.Label>Name of Parent if visitor is minor</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="name_of_parent_if_minor"
                                        placeholder='Name of Parent if visitor is minor'
                                        value={newAppointmentDetailsState.name_of_parent_if_minor || ""}
                                        onChange={(oEvent) => {
                                            oEvent.target.value = oEvent.target.value.toUpperCase()
                                            fnOnChange(oEvent, newAppointmentDetailsState, setNewAppointmentDetailsState, newAppointmentDetailsErrors, setNewAppointmentDetailsErrors)
                                        }
                                        }
                                        isInvalid={newAppointmentDetailsErrors.name_of_parent_if_minor}
                                    />
                                    <Form.Control.Feedback type="invalid">{newAppointmentDetailsErrors.name_of_parent_if_minor}</Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className={checkVisitorType === "" ? 'd-none' : 'mb-3'} controlId="formMobileNumber">
                                    <Form.Label className="required">Mobile Number</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="mobile_number"
                                        placeholder='Mobile Number'
                                        value={newAppointmentDetailsState.mobile_number || ""}
                                        onChange={(oEvent) => fnOnChange(oEvent, newAppointmentDetailsState, setNewAppointmentDetailsState, newAppointmentDetailsErrors, setNewAppointmentDetailsErrors)}
                                        isInvalid={newAppointmentDetailsErrors.mobile_number}
                                    />
                                    <Form.Control.Feedback type="invalid">{newAppointmentDetailsErrors.mobile_number}</Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className={checkVisitorType === "" ? 'd-none' : 'mb-3'} controlId="formEmailID">
                                    <Form.Label>Email ID</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="email_id"
                                        placeholder='Email ID'
                                        value={newAppointmentDetailsState.email_id || ""}
                                        onChange={(oEvent) => fnOnChange(oEvent, newAppointmentDetailsState, setNewAppointmentDetailsState, newAppointmentDetailsErrors, setNewAppointmentDetailsErrors)}
                                        isInvalid={newAppointmentDetailsErrors.email_id}
                                    />
                                    <Form.Control.Feedback type="invalid">{newAppointmentDetailsErrors.email_id}</Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className={checkVisitorType === "" ? 'd-none' : 'mb-3'} controlId="formPatientAddress">
                                    <Form.Label>Address</Form.Label>
                                    <Form.Control as="textarea" rows={3}
                                        name="patient_address"
                                        placeholder='Address'
                                        value={newAppointmentDetailsState.patient_address || ""}
                                        onChange={(oEvent) => {
                                            oEvent.target.value = oEvent.target.value.toUpperCase()
                                            fnOnChange(oEvent, newAppointmentDetailsState, setNewAppointmentDetailsState, newAppointmentDetailsErrors, setNewAppointmentDetailsErrors)
                                        }
                                        }
                                        isInvalid={newAppointmentDetailsErrors.patient_address}
                                    />
                                    <Form.Control.Feedback type="invalid">{newAppointmentDetailsErrors.patient_address}</Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className={checkVisitorType === "" ? 'd-none' : 'mb-3'} controlId="formPatientCity">
                                    <Form.Label>City</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="patient_city"
                                        placeholder='City'
                                        value={newAppointmentDetailsState.patient_city || ""}
                                        onChange={(oEvent) => {
                                            oEvent.target.value = oEvent.target.value.toUpperCase()
                                            fnOnChange(oEvent, newAppointmentDetailsState, setNewAppointmentDetailsState, newAppointmentDetailsErrors, setNewAppointmentDetailsErrors)
                                        }
                                        }
                                        isInvalid={newAppointmentDetailsErrors.patient_city}
                                    />
                                    <Form.Control.Feedback type="invalid">{newAppointmentDetailsErrors.patient_city}</Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formClinicBranchId">
                                    <Form.Label className="required">Clinic Branch</Form.Label>
                                    <Form.Control
                                        as={FormSelect}
                                        name="clinic_branch_id"
                                        value={newAppointmentDetailsState.clinic_branch_id || ""}
                                        onChange={(oEvent) => fnOnChange(oEvent, newAppointmentDetailsState, setNewAppointmentDetailsState, newAppointmentDetailsErrors, setNewAppointmentDetailsErrors)}
                                        isInvalid={newAppointmentDetailsErrors.clinic_branch_id}>
                                        <option value="">Select Clinic Branch</option>
                                        {clinicBranchDetails.map((branch) => (
                                            <option key={branch.clinic_branch_id} value={branch.clinic_branch_id}>
                                                {branch.branch_address}
                                            </option>
                                        ))}
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">{newAppointmentDetailsErrors.clinic_branch_id}</Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formAppointmentDate">
                                    <Form.Label className="required">Appointment Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="appointment_date"
                                        value={newAppointmentDetailsState.appointment_date || ""}
                                        onChange={(oEvent) => fnOnChange(oEvent, newAppointmentDetailsState, setNewAppointmentDetailsState, newAppointmentDetailsErrors, setNewAppointmentDetailsErrors)}
                                        isInvalid={newAppointmentDetailsErrors.appointment_date}
                                    />
                                    <Form.Control.Feedback type="invalid">{newAppointmentDetailsErrors.appointment_date}</Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formAppointmentTime">
                                    <Form.Label className="required">Appointment Time</Form.Label>
                                    <CustomTimePicker
                                        controlId='formAppointmentTimePicker'
                                        name="appointment_time"
                                        value={newAppointmentDetailsState.appointment_time || ""}
                                        onChange={(oEvent) => fnOnChange(oEvent, newAppointmentDetailsState, setNewAppointmentDetailsState, newAppointmentDetailsErrors, setNewAppointmentDetailsErrors)}
                                        isInvalid={newAppointmentDetailsErrors.appointment_time}
                                    />
                                    <Form.Control.Feedback type="invalid">{newAppointmentDetailsErrors.appointment_time}</Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formAppointment">
                                    <Button type="submit" variant="primary" disabled={userDetails.user_type === "M"} className="form-control" onClick={onPressSubmitNewAppointment}>
                                        {isSubmitting ? 'Booking Appointment...' : 'Book Appointment'}
                                    </Button>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                </Row>
            </Container>
            <ToastContainer />
            <BusyLoaderOverlay show={loading} />
        </>
    )
}

export default NewAppointment